import React from 'react'
import EmployeeErrors404Comp from '../../../components/Employee/errors/errors_404'

export default function EmployeeError404 () {
  return (
    <>
      <EmployeeErrors404Comp />
    </>
  )
}